import { graphql } from 'gql';

export const isUniqueLimitedNameGql = graphql(`
    query isUniqueLimitedCostType($id: Int, $input: CatalogLimitedCostTypeInput!) {
        isUniqueLimitedCostType(id: $id, input: $input) {
            result
        }
    }
`);

export const getLimitedCostTypesGql = graphql(`
    query limitedCostTypes($methodology: ProjectMethodologyEnum!) {
        limitedCostTypes(methodology: $methodology) {
            canDelete
            id
            isSystem
            name
            uniqueId
        }
    }
`);

export const createCatalogLimitedCostTypeGql = graphql(`
    mutation createCatalogLimitedCostType($input: CatalogLimitedCostTypeInput!) {
        createCatalogLimitedCostType(input: $input) {
            result
            message
            validation {
                property
                message
            }
        }
    }
`);

export const updateCatalogLimitedCostTypeGql = graphql(`
    mutation updateCatalogLimitedCostType($id: Int!, $input: CatalogLimitedCostTypeInput!) {
        updateCatalogLimitedCostType(id: $id, input: $input) {
            result
            message
            validation {
                property
                message
            }
        }
    }
`);

export const removeLimitedCostTypeGql = graphql(`
    mutation removeLimitedCostType($id: Int!) {
        removeCatalogLimitedCostType(id: $id) {
            result
            message
            id
        }
    }
`);
